import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B02cUserListPage } from '../b02c-user-list/b02c-user-list';
import { B02UserManagementPage } from '../b02-user-management/b02-user-management';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B02dUserAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-b02d-user-add',
  templateUrl: 'b02d-user-add.html',
})
export class B02dUserAddPage {
  private todo : FormGroup;
  loading: any;
  Status: any;

  userData =  { LOGIN: '', PASSWORD:'', USER_NAME:'',
                BRANCH_ID: '', GRP_ID: '', CORP_ID: null, 
                USER_ACTIVE:'YES',
              }
  Password1: any;
  Password2: any;
  public errorMessage: any = "";

constructor(public navCtrl: NavController, public navParams: NavParams, private formBuilder: FormBuilder, 
            public serviceapi: ServiceApiProvider, public loadingCtrl: LoadingController) {

  this.todo = this.formBuilder.group({
    username: ['', Validators.required],
    usergroup: ['', Validators.required],
    password1: ['', Validators.required],
    password2: ['', Validators.required],
    active: ['', Validators.required],
  });

  this.userData.BRANCH_ID = this.navParams.get('parambranchId');    //corporate ID
}

  ionViewDidLoad() {
    console.log('ionViewDidLoad B02dUserAddPage');
  }

  save(){
    if (this.validateNoSpecialContain(this.userData.USER_NAME) != true) {
      this.errorMessage = "Username Contains Invalid Characters";
    }
    else if (this.Password1 != this.Password2) {                //check password 1 match with password 2
      this.errorMessage = "Password Mismatch";
    }
    else {
      this.userData.PASSWORD = this.Password1;                  //assign password
      delete this.userData.CORP_ID;                             //delete corp ID, not use
      delete this.userData.LOGIN;                               //delete login, not use
      console.log(this.userData);
      this.showLoader();
      this.serviceapi.insertdata("USER",this.userData).then((result) => {
        this.loading.dismiss();
        this.Status = result["Message"];
        
        if (this.Status == "1"){
          this.navCtrl.setRoot(B02cUserListPage, {paramID: this.userData.BRANCH_ID});
        }
        else {
          this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        }
      }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
      });
    }
  }

  cancel(){
    this.navCtrl.pop();
  }

  goTo(){
    this.navCtrl.setRoot(B02UserManagementPage);
  }

  goTo2(){
    this.navCtrl.setRoot(B02cUserListPage, {paramID: this.userData.BRANCH_ID});
  }

  showLoader(){    
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }

  validateNoSpecialContain(s) {
    //Regex for Valid Characters i.e. Alphabets, Numbers.
    var regex = /^[A-Za-z0-9_]+$/

    //Validate TextBox value against the Regex.
    var isValid = regex.test(s);

    return isValid;
  }
}



// WEBPACK FOOTER //
// ./src/pages/b02d-user-add/b02d-user-add.ts